export default "__VITE_ASSET__88ll0Mxs__"